"use strict";function setRule$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.setRule$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.contact.setRule";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.15"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.15"},_a)),exports.setRule$=setRule$,exports.default=setRule$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/contact/setRule.js
// module id = 937
// module chunks = 106